<template>
  <div>
    <Login1 v-if="entpType == '2'"></Login1>
    <Login v-else></Login>
  </div>
</template>

<script>
import Login from "./login.vue";
import Login1 from "./login_v1.vue";
import { mapGetters } from "vuex";
import store from '@/store'

export default {
  components: {
    Login,
    Login1,
  },
  // data(){
  //   return {
  //     entpType :'2'
  //   }
  // },
  computed: {
    ...mapGetters(["entpType"]),
  },
  // 历史遗留问题，等待获取配置信息
  beforeRouteEnter(to, from, next){
    let waitTime = 0
    if(store.getters.entpType != ''){
      next()
      return
    }
    let t = setInterval(()=>{
      waitTime+=1
      if(waitTime==20 || store.getters.entpType != ''){
        console.log('wait',waitTime)
        clearInterval(t)
        t= null
        next()
      }
    },300)
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/login/main.vue